import { UserLocale } from '@mnd-frontend/graphql-schema';

export const getSdrEmail = (locale: UserLocale) => {
  switch (locale) {
    case UserLocale.Sv:
      return 'sdr.sweden@mynewsdesk.com';
    case UserLocale.Da:
      return 'sdr.denmark@mynewsdesk.com';
    case UserLocale.No:
      return 'sdr.norway@mynewsdesk.com';
    case UserLocale.De:
      return 'sdr.germany@mynewsdesk.com';
    default:
      return 'sdr.global@mynewsdesk.com';
  }
};

export const supportEmail = 'support@mynewsdesk.com';

export const mediaMonitorTeamEmail = 'mediamonitoring@mynewsdesk.com';
